// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-divider[data-v-60d06220] {\n  margin: 0;\n  border-radius: 4px;\n  border-left: 0px;\n  border-right: 0px;\n  border-bottom: 0px;\n  border-top: var(--d-weight) var(--d-style) var(--d-color);\n  width: var(--d-width);\n}", ""]);
// Exports
module.exports = exports;
